import * as BABYLON from 'babylonjs'
import { EventBus } from '@/js/EventBus.js'

export var pantallas = []

export function getSlug (str) {
  str = str.toLowerCase()
  return str.replace(/ /g,'-')
}

/* Funciones de inspección por clic */
function alertId (mesh, id) {
  // console.log(id + '.agregando la accion...' + mesh)
  mesh.actionManager = new BABYLON.ActionManager(window.scene)
  mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
    console.log('mesh ' + id + '....' + mesh)
    EventBus.$emit('selectEvent', mesh)
  }))

  // environment.localAvatar.target.x =
  // mesh.
  return mesh
}
function alertIdInstancia (instance, idParent, id) {
  // console.log(id + '.(instancia)agregando la accion...' + instance)
  instance.actionManager = new BABYLON.ActionManager(window.scene)
  instance.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
    console.log('instancia ' + idParent + '->' + id + '....' + instance)
    EventBus.$emit('selectEvent', instance)
  }))
  return instance
}
export function inspectorClic (newMeshes) {
  for (var i = 0; i < newMeshes.length; i++) {
    newMeshes[i] = alertId(newMeshes[i], i)
    if (typeof newMeshes[i].instances !== 'undefined') {
      for (var j = 0; j < newMeshes[i].instances.length; j++) {
        // console.log('instancia ' + newMeshes[i] + '->' + newMeshes[i].instances[j] + '....')
        newMeshes[i].instances[j] = alertIdInstancia(newMeshes[i].instances[j], i, j)
      }
    }
  }
  return newMeshes
}
/* Fin Funciones de inspección por clic */

export function objectConfigurations (hObject, newMeshes) {
  let hApp = hObject.hApp
  var i, j

  newMeshes = inspectorClic(newMeshes)

  // Registrando los meshes cargados al hObject
  for (i = 0; i < newMeshes.length; i++) {
    hObject.meshes.push(newMeshes[i])
    if (typeof newMeshes[i].instances !== 'undefined') {
      for (j = 0; j < newMeshes[i].instances.length; j++) {
        hObject.meshes.push(newMeshes[i].instances[j])
      }
    }
  }

  // Renombrando meshes según jerarquía hApp.hObject.mesh
  for (i = 0; i < newMeshes.length; i++) {
    newMeshes[i].name = hApp.name + '.' + hObject.name + '.' + newMeshes[i].name
    if (typeof newMeshes[i].instances !== 'undefined') {
      for (j = 0; j < newMeshes[i].instances.length; j++) {
        newMeshes[i].instances[j].name = hApp.name + '.' + newMeshes[i].instances[j].name
      }
    }
  }

  // Ubicación del mesh padre
  var meshRoot = window.scene.getMeshByName(hApp.name + '.' + hObject.name + '.root')
  if (meshRoot === null) {
    meshRoot = newMeshes[0]
  }

  // Activando colisiones
  for (i = 0; i < newMeshes.length; i++) {
    newMeshes[i].checkCollisions = true
    if (typeof newMeshes[i].instances !== 'undefined') {
      for (j = 0; j < newMeshes[i].instances.length; j++) {
        newMeshes[i].instances[j].checkCollisions = true
      }
    }
  }

  // Emparentando instancias
  for (i = 0; i < newMeshes.length; i++) {
    if (typeof newMeshes[i].instances !== 'undefined') {
      for (j = 0; j < newMeshes[i].instances.length; j++) {
        newMeshes[i].instances[j].parent = meshRoot
      }
    }
  }

  // Ajuste de la posición de meshRoot a partir de la posición del hObjeto y del hApp
  meshRoot.position.x = hApp.content.position.x + hObject.position.x
  meshRoot.position.z = hApp.content.position.z + hObject.position.z
  meshRoot.position.y = hApp.content.position.y + hObject.position.y
  meshRoot.rotation.x = Math.PI * hObject.rotation.x / 180
  meshRoot.rotation.z = Math.PI * hObject.rotation.z / 180
  meshRoot.rotation.y = Math.PI * hObject.rotation.y / 180
  // Hacer codigo para dispose según arreglo en object
  // newMeshes[8].dispose()

  // Aplicando la visibilidad a los meshes según la visibilidad del hObject
  // for (i = 0; i < newMeshes.length; i++) {
  //   newMeshes[i].visibility = hObject.visible
  //   for (j = 0; j < newMeshes[i].instances.length; j++) {
  //     newMeshes[i].instances[j].visibility = hObject.visible
  //   }
  // }
}

export function inPerimeter (radio, x1, y1, x2, y2) {

  var distancia = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2))
  // console.log('distancia:')
  // console.log(distancia)
  if (Math.abs(distancia) < radio) {
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/core/utils.js